<template>
  <el-dialog :visible.sync="dialogVisible" append-to-body :close-on-click-modal="false" top="10vh" class="create-project-dialog" width="600px">
    <div slot="title" class="dialog-title">题库<span class="field-alert">（包含公司常用问题）</span></div>
    <div>
      <div class="flex mb10">
        <el-input
          v-model="keyword"
          size="mini"
          placeholder="问题关键字搜索，关键词之间用空格分开"
          @keyup.enter.native="loadData(keyword)"
        ></el-input>
        <el-button size="mini" class="ml10" type="primary" @click="loadData(keyword)">搜索</el-button>
      </div>
      <div v-loading="loading" class="question-box mb10">
        <div v-for="(item, index) in questiones" :key="`question${index}`" class="question-item">
          <span v-if="checkHasQuestion(item)" class="text-btn" @click="chooseQuestion(item)">选择</span>
          <span v-else class="text-btn warning-text" @click="cancelChooseQuestion(item)">取消</span>
          <div class="flex-auto">
            <div class="flex align-center mb10">
              <span class="mr10" style="align-self:flex-start">Q:</span> <span>{{ item.question }}</span>
            </div>
            <div class="flex align-center">
              <span class="mr10">A:</span> <span>{{ item.answer || '' }}</span>
            </div>
          </div>
        </div>
      </div>
      <el-pagination
        background
        :current-page="page"
        :page-size="pageSize"
        layout="total, prev, pager, next, jumper"
        :total="total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      ></el-pagination>
      <!-- <div class="footer-box">
        <div class="flex" style="flex-direction: column;flex:none">
          <el-button class="mb10" type="primary" size="mini" @click="toProjectDetail">不填了，直接立项</el-button>
        </div>
      </div> -->
    </div>

    <!--
    <span slot="footer" class="dialog-footer">
      <el-button size="mini" class="mr10" @click="dialogVisible = false">取 消</el-button>
      <el-button size="mini" type="primary" @click="confirm">确 定</el-button>
    </span> -->
  </el-dialog>
</template>
<script>
export default {
  props: {
    hasQuestiones: { type: Array, default: () => [] },
  },
  data() {
    return {
      dialogVisible: false,
      keyword: '',
      questiones: [],
      page: 1,
      total: 0,
      pageSize: 10,
      loading: false,
    }
  },
  methods: {
    open() {
      this.keyword = ''
      this.dialogVisible = true
      this.loadData()
    },
    checkHasQuestion(item) {
      const val = this.hasQuestiones.find(v => v.Q === item.question && v.A === item.answer)
      return !val
    },
    chooseQuestion(item) {
      this.$emit('addQuestion', { Q: item.question, A: item.answer })
    },
    cancelChooseQuestion(item) {
      this.$emit('removeQuestion', { Q: item.question, A: item.answer })
    },
    handleCurrentChange(val) {
      this.page = val
      this.loadData()
    },
    handleSizeChange(val) {
      this.pageSize = val
      this.loadData()
    },
    async loadData() {
      const keywords = this.keyword.split(' ').filter(v => v)
      this.loading = true
      const res = await app.service('company').findQuestion({
        keywords,
        paginate: {
          page: this.page,
          pageSize: this.pageSize,
          sort: this.sort,
        },
      })
      if (res.status === 'success') {
        const { data, page, pageSize, total } = res
        this.questiones = data
        this.page !== page && (this.page = page)
        this.pageSize !== pageSize && (this.pageSize = pageSize)
        this.total !== total && (this.total = total)
      } else {
        this.questiones = []
        this.$message.error(res.msg)
      }
      this.loading = false
    },
  },
}
</script>
<style>
.create-project-dialog .el-dialog__body {
  padding-top: 0px;
}
</style>
<style scoped src="../../css/newCreateProject.css"></style>
<style scoped>
.hasset-field-box {
  display: flex;
  flex-wrap: wrap;
}
.hasset-field {
  flex: none;
  min-width: 100px;
  margin: 10px;
}
.footer-box {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px 0;
}
.dialog-title {
  font-size: 16px;
  text-align: center;
  border-bottom: 1px solid #d4d4d4;
  padding-bottom: 8px;
}
.create-project-alert-box {
  border: 1px solid #d4d4d4;
  padding: 10px;
  border-radius: 4px;
}
.question-item {
  padding-top: 5px;
  padding-bottom: 10px;
  border-bottom: 1px solid #eee;
  display: flex;
}
.text-btn {
  font-size: 12px;
  cursor: pointer;
  color: #409eff;
  margin-right: 20px;
  flex: none;
  word-break: keep-all;
}

.warning-text {
  color: #f56c6c;
}
.mt10 {
  margin-top: 10px;
}
</style>
